import { Hero } from "../components/Hero";
import { Marquee } from "../components/Marquee";
import { Inventory } from "../components/Inventory";
import { Services } from "../components/Services";
import { Showroom } from "../components/Showroom";
import { Contact } from "../components/Contact";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Hero />
      <Marquee />
      <Inventory />
      <Services />
      <Showroom />
      <Contact />
    </main>
  );
}
